module.exports = __webpack_public_path__ + "img/2.7a205b3c.jpg";